import React from 'react';
import 'App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from 'Pages/Layout';
import Plants from 'Pages/Plants';
import GerminationTrays from 'Pages/GerminationTrays';
import GerminationTray from 'Pages/GerminationTray';
import Garden from 'Pages/Garden';
import NoPage from 'Pages/NoPage';
import Login from 'Pages/Login';
import Register from 'Pages/Register';
import { GoogleOAuthProvider } from '@react-oauth/google';

const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

if (!googleClientId) {
  throw new Error('REACT_APP_GOOGLE_CLIENT_ID must be defined to run the app.');
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            {/* <Route index element={<Home />} /> */}
            <Route index element={<GerminationTrays />} />
            <Route path="plants" element={<Plants />} />
            <Route path="germinationTray/:id" element={<GerminationTray />} />
            <Route path="germinationTrays" element={<GerminationTrays />} />
            <Route path="garden" element={<Garden />} />

            <Route path="login" element={
              <GoogleOAuthProvider clientId={googleClientId ?? ""}>
                <Login />
              </GoogleOAuthProvider>
            } />
            <Route path="register" element={
              <GoogleOAuthProvider clientId={googleClientId ?? ""}>
                <Register />
              </GoogleOAuthProvider>
            } />

            <Route path="*" element={<NoPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
